<template lang="pug">
    .page.event
        .head.container
            calendar-title.black.small
            slider-list(v-if="sliderDates"
                :slides="sliderDates"
                :activeSlide="activeSliderDate"
                @slideChange="changeDate"
                :class="{disabled: !loaded}")
        event-fixed-header(v-if="isMobileOrTablet && event")
            events-mobile-slider(:events="currentDay.EVENTS"
                :prevEvent="event.prev"
                :nextEvent="event.next"
                :activeSlide="event.active"
                @slideChange="changeEvent"
                :key="event.current.CODE"
                :class="{disabled: !loaded}")
        main
            transition-group(name="fade")
                .contentWrapper(v-show="loaded" key="1")
                    .main
                        .arrows.container.small(v-if="event")
                            .arrow.prev(:class="{disabled: !event.prev}" @click="changeEvent(event.prev)")
                            .arrow.next(:class="{disabled: !event.next}" @click="changeEvent(event.next)")

                        .content(v-if="event && event.current")
                            .container.small
                                h1(v-html="event.current.NAME")
                                h6
                                    router-link.link(tag="span" :to="'/allevents?tag='+event.current.EVENT_TAG") {{event.current.EVENT_STATUS}} - {{event.current.EVENT_TAG}}
                                    .app_btn.subscribe.white_fill(v-if="event.current.SUBSCR_AVAILABLE" @click="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'event', code: event.current.CODE, name: event.current.NAME})") {{$t('other.subscribeToUpdates')}}
                                img.content_img(v-if="event.current.PREVIEW_PICTURE" :src="event.current.PREVIEW_PICTURE" alt="Превью")

                        .detail(v-html="eventDetail")

                        .container.small(v-if="event && event.current")
                            sharing(:url="sharingUrl"
                                :title="event.current.NAME"
                                :description="''")

                        .bottom.container(v-if="currentDay")
                            router-link.app_btn.white_fill(tag="div" :to="'/'+currentDay.CODE") {{$t('event.watchAllEvents')}}
                        br
                        br
                        br
                        br
                    .blocks
                        .content
                            .container
                                .app_title {{$t('other.newCalendarEvents')}}
                                events-grid
                                    router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in new_events" :key="ind")
                                        event-card(:event="event")
                        .content
                            .container
                                .app_title {{$t('other.mayInteresting')}}
                                events-grid
                                    router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in popular_events" :key="ind")
                                        event-card(:event="event")
                    .main
                        .bottom.container
                            .app_btn.white_fill(v-anchor="'.event'") {{$t('other.up')}}

                preloader(v-show="!loaded" key="2")

        parallax-figures_event.forDesktop
        parallax-figures_home.forMobile_or_p
</template>

<script>
    import CalendarTitle from "../components/other/CalendarTitle";
    import SliderList from "../components/elements/SliderList";
    import EventsGrid from "../components/elements/EventsGrid";
    import EventCard from "../components/elements/EventCard";
    import ParallaxFigures_event from "../components/other/ParallaxFigures_event";
    import ParallaxFigures_home from "../components/other/ParallaxFigures_home";
    import Preloader from "../components/other/Preloader";
    import Sharing from "../components/elements/Sharing";
    import EventFixedHeader from "../components/app/EventFixedHeader.vue";
    import EventsMobileSlider from "../components/elements/EventsMobileSlider";
    import { mapState } from 'vuex';
    export default {
        name: "Event",
        data:()=>({
            currentDay: null,
            event: null,
            eventDetail: '',

            loaded: true,
        }),
        computed:{
            ...mapState([
                'isMobileOrTablet',
                'calendar',
                'new_events',
                'popular_events',
            ]),
            sharingUrl(){
                return `${this.$locationPath}sharing.php?url=${this.$locationPath}${this.$route.params.date}/${this.$route.params.id}&title=${this.event.current.NAME}&description=`
            },
            datesWithEvents(){
                let dates = [];
                this.calendar.forEach(m=>{
                    dates = [...dates, ...m.DAYS];
                });
                return dates.filter(d=>d.EVENTS.length);
            },
            sliderDates(){
                return this.datesWithEvents.map(d=>({name: d.NAME, id: d.CODE}))
            },
            activeSliderDate(){
                return this.sliderDates.findIndex(d=>this.currentDay && d.id === this.currentDay.CODE)
            },
        },
        methods:{
            changeDate(id){
                if (id === this.$route.params.date) return;
                let d = this.datesWithEvents.find(el=>el.CODE === id);
                this.changeEvent(d.EVENTS[0]);
            },
            changeEvent(event){
                this.$router.push('/'+event.DAY_CODE+'/'+event.CODE);
            },
            fetchEvent(code){
                if (!this.loaded) return;
                this.loaded = false;
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                setTimeout(async ()=>{
                    try {
                        let {data} = await this.axios.get('?ACTION=getEvent&CODE='+code);
                        if (data.STATUS === 'ok') {
                          if (data.DATA.AVAILABLE_VIEWING === 'N') {
                            this.$router.push("/")
                            return
                          }
                          this.eventDetail = data.DATA.DETAIL_TEXT;
                            this.currentDay = this.datesWithEvents.find(d=>d.CODE === data.DATA.DAY_CODE);

                            let events = this.currentDay.EVENTS;
                            let currentEventIndex = events.findIndex(e=>e.CODE===this.$route.params.id);
                            this.event = {
                                current: events[currentEventIndex],
                                next: events[currentEventIndex+1],
                                prev: events[currentEventIndex-1],
                                active: currentEventIndex,
                            };
                            this.updateWatchedEvents(code);

                            setTimeout(()=>{
                                this.loaded = true;
                                setTimeout(()=>{
                                    this.initVideos();
                                    this.initAudios();
                                    this.initGalleries();
                                });
                            }, 200)
                        }else{
                            this.loaded = true;
                        }
                    } catch (e) {
                        this.loaded = true;
                        console.log(e);
                    }
                }, 600)
            },
            updateWatchedEvents(code){
                let watchedList = this.$cookie.get('watchedList');
                if (watchedList){
                    watchedList = JSON.parse(watchedList)
                }else{
                    watchedList = {};
                }
                watchedList[code] = Date.now();
                this.$cookie.set('watchedList', JSON.stringify(watchedList));
            },
            initVideos(){
                let players = document.querySelectorAll('.app_video');
                Array.prototype.forEach.call(players, (p)=>{
                    let videoData = JSON.parse(p.getAttribute('data-setup'));
                    if (videoData && videoData.techOrder && videoData.techOrder[0] === 'youtube'){
                        p.setAttribute('poster', `https://img.youtube.com/vi/${youtube_parser(videoData.sources[0].src)}/0.jpg`)
                    }
                    let player = videojs(p.getAttribute('id'), this.options);
                });
                function youtube_parser(url){
                    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                    var match = url.match(regExp);
                    return (match&&match[7].length==11)? match[7] : false;
                }
            },
            initAudios(){
                let audios = document.querySelectorAll('.app_audio');
                Array.prototype.forEach.call(audios, audio=>{
                    init(audio)
                })
                function init(audio) {
                    let name = audio.getAttribute('data-name');
                    let src = audio.getAttribute('data-src');
                    let id = audio.getAttribute('id');

                    audio.innerHTML = `<div class="jp-jplayer"></div>
                                        <div class="jp-audio">
                                            <div class="jp-type-playlist">
                                                <div class="jp-gui jp-interface">
                                                    <ul class="jp-controls">
                                                        <li><label class="name">${name}</label></li>
                                                        <li><a class="jp-play" href="javascript:;" tabindex="1">play</a></li>
                                                        <li><a class="jp-pause" href="javascript:;" tabindex="1">pause</a></li>
                                                    </ul>
                                                    <div class="jp-progress">
                                                        <div class="jp-seek-bar">
                                                            <div class="jp-play-bar"></div>
                                                        </div>
                                                    </div>
                                                    <div class="jp-volume-bar">
                                                        <div class="jp-volume-bar-value"></div>
                                                    </div>
                                                    <div class="jp-time-holder">
                                                        <div class="jp-current-time"></div>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                                <div class="jp-playlist">
                                                    <ul>
                                                        <li></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>`;
                    let cssSelector = {
                        jPlayer: '#'+id+' .jp-jplayer',
                        cssSelectorAncestor:  '#'+id+' .jp-audio'
                    };
                    let playlist = [
                        {
                            author:"TSP",
                            title:"Cro Magnon Man",
                            discription: "Привет, я  описание",
                            mp3: src,
                        },
                    ];
                    let options = {
                        swfPath: "js",
                        supplied: "oga, mp3",
                        wmode: "window",
                        smoothPlayBar: false,
                        keyEnabled: true
                    };
                    let myPlaylist = new jPlayerPlaylist(cssSelector, playlist, options);
                }
            },
            initGalleries(){
                let galleries = document.querySelectorAll('.app_gallery');
                Array.prototype.forEach.call(galleries, g=>{
                    new Swiper(g.querySelector('.swiper-container'), {
                        grabCursor: true,
                        navigation: {
                            prevEl: g.querySelector('.swiper-button-prev'),
                            nextEl: g.querySelector('.swiper-button-next'),
                        },
                        pagination: {
                            el: g.querySelector('.swiper-pagination'),
                            type: 'bullets',
                            clickable: true,
                        },
                    })
                })
            }
        },
        watch:{
            $route(){
                this.fetchEvent(this.$route.params.id);
            },
        },
        created(){
            this.fetchEvent(this.$route.params.id);
        },
        components: {
            EventsMobileSlider,
            EventFixedHeader,
            Sharing,
            Preloader,
            ParallaxFigures_home, ParallaxFigures_event, EventCard, EventsGrid, SliderList, CalendarTitle}
    }
</script>

<style scoped lang="scss">

    .event {
        position: relative;
        min-height: 100vh;
        padding-bottom: 5rem;
        background: #fff;
        color: #000;
    }
    .preloader{
        position: absolute;
        top: 2rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .head {
        max-width: 91.7rem;
        margin-bottom: 1rem;
        padding-top: 1.3rem;

        .calendarTitle {
            margin-bottom: 0.7rem;
        }

        .sliderList {
            margin-left: 1rem;
        }
    }

    main {
        position: relative;
        display: block;
        &::v-deep {
            .main {

                .container {
                    position: relative;
                    z-index: 1;
                    max-width: 91.7rem;
                }

                .container.small {
                    padding: 0 9.9rem;
                }

                .content {
                    transform: translateZ(0); // фикс relative внутреннего элемента
                    margin-bottom: 5rem;

                    &.grey {
                        background: #f0efef;
                    }

                    &.red {
                        background: $red;
                    }

                    &.blue {
                        background: $blue;
                    }
                }

                h1 {
                    margin-bottom: 0.3rem;
                    font-size: to_rem(70px);
                    line-height: 1.2;
                    color: #2b2b2b;
                }

                h2 {
                    margin: 1.8rem 0;
                    font-family: Arial;
                    font-size: to_rem(32px);
                    line-height: 1.3;
                }

                h3 {
                    margin: 2rem 0;
                    font-family: Arial;
                    font-size: to_rem(25px);
                    font-weight: bold;
                }

                h6 {
                    margin-bottom: 1.6rem;
                    font-size: 1.25rem;
                    .link{
                        cursor: pointer;
                        transition: text-shadow .2s;
                        &:hover{
                            text-shadow: 0 0 1.5rem rgba(#000, 0.5);
                        }
                    }

                    .app_btn {
                        margin-left: 1.5rem;
                    }
                }

                p {
                    margin: 1rem 0 2rem;
                    font-family: Arial;
                    font-size: to_rem(18px);
                    line-height: 1.5;
                }

                a {
                    position: relative;
                    color: $red;

                    &:before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        height: 1px;
                        background: $red;
                    }
                }

                ul, ol {
                    li {
                        position: relative;
                        margin: 0.56rem 0;
                        font-family: Arial;
                        font-size: to_rem(18px);

                        &:before {
                            display: block;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);

                        }
                    }
                }

                ul {
                    padding-left: 3.5rem;

                    li {
                        &:before {
                            content: '';
                            left: -0.7rem;
                            width: 4px;
                            height: 4px;
                            border-radius: 50%;
                            background: $blue;

                        }
                    }
                }

                ol {
                    padding-left: 4rem;
                    counter-reset: num;

                    li {
                        &:before {
                            content: counter(num) '.';
                            counter-increment: num;
                            left: -1.3rem;
                            color: $blue;
                        }
                    }
                }

                table {
                    width: 100%;
                    margin: 2rem 0 3rem;
                    table-layout: fixed;
                    font-family: Arial;
                    font-size: to_rem(18px);

                    tr {
                        &:nth-of-type(1) {
                            background: #f5f5f5;
                        }

                        td, th {
                            padding: 0.95rem;
                            border: 2px solid #e8e8e8;
                            text-align: center;

                        }
                    }
                }
                img{
                    max-width: 100%;
                }
                .content_img {
                    width: 100%;
                    border-radius: 1rem;
                }

                blockquote {
                    display: flex;
                    justify-content: space-between;
                    margin: 0;
                    padding-top: 2.2rem;

                    img {
                        flex-shrink: 0;
                        align-self: flex-end;
                        margin-right: 1rem;
                    }

                    & > a {
                        max-width: 71%;
                        padding: 1.7rem 0;
                    }

                    h3 {
                        margin: 0 0 2.9rem;
                        font-family: BebasNeueBook, Arial;
                        font-size: to_rem(50px);
                        line-height: 1.2;
                        font-weight: 400;
                    }

                    small {
                        display: block;
                        font-family: Arial;
                        font-size: to_rem(25px);
                    }
                }

                .app_video {
                    width: 50rem;
                    height: 26rem;
                    max-width: 100%;
                    margin: 0 auto;
                }

                .app_audio {
                    width: 50rem;
                    max-width: 100%;
                    margin: 0 auto 1rem;
                }

                .app_gallery {
                    margin: 3.5rem 0;

                    .swiper-container {
                        position: relative;
                        border-radius: 1rem;

                        &:before {
                            content: '';
                            display: block;
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            z-index: 2;
                            background: linear-gradient(to right, rgba(#000, 0.5) 0%, transparent 15%, transparent 85%, rgba(#000, 0.5) 100%);
                            pointer-events: none;
                        }
                    }

                    .swiper-slide {
                        height: 33rem;
                        background: no-repeat center center / cover;
                    }

                    .swiper-button-prev, .swiper-button-next {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 3rem;
                        height: 5.2rem;
                        margin-top: 0;
                        background: url(../assets/img/arrow_white_3.png) no-repeat center center / contain;
                        cursor: pointer;

                        &.swiper-button-prev {
                            left: 0.9rem;
                            transform: translateY(-50%) scale(-1, 1);
                        }

                        &.swiper-button-next {
                            right: 0.9rem;
                            transform: translateY(-50%);
                        }
                    }

                    .swiper-pagination {
                        top: calc(100% + 1.4rem);
                        left: 50%;
                        transform: translateX(-50%);

                        &-bullet {
                            width: 0.5rem;
                            height: 0.5rem;
                            margin: 0 0.5rem;
                            background: $red;
                            opacity: 1;

                            &-active {
                                background: #adadad;
                            }
                        }
                    }
                }
            }
            .blocks {
                .container {
                    position: relative;
                    z-index: 1;
                    max-width: 91.7rem;
                }
            }
        }
    }

    .arrows {
        position: relative;

        &.container {
            z-index: 2;
        }

        .arrow {
            position: absolute;
            top: 5.2rem;
            transform: translateY(-50%);
            width: 3rem;
            height: 5rem;
            background: url(../assets/img/arrow_black.png) no-repeat center center / contain;
            cursor: pointer;

            &.prev {
                left: 2.75rem;
                transform: translateY(-50%) scale(-1, 1);
            }

            &.next {
                right: 2.75rem;
                transform: translateY(-50%);
            }
            &.disabled{
                opacity: 0.2;
                pointer-events: none;
            }
        }
    }


    .sharing{
        margin-top: -2.5rem;
        margin-bottom: 2rem;
    }

    .bottom {
        display: flex;
        justify-content: center;
    }

    @include mobile_or_P {
        .head {
            margin-bottom: 1.5rem;
            padding-top: 0;

            .calendarTitle {
                margin-bottom: 0;
            }

            .sliderList {
                margin: 0 auto;
            }
        }
        main {
            &::v-deep{
                .main {
                    .container.small {
                        padding: 0 1.5rem;
                    }

                    .content {
                        margin-bottom: 3rem;
                    }
                    h1, h6 {
                        max-width: 22.3rem;
                        margin: 0 auto;
                    }

                    h1 {
                        margin-bottom: 0.75rem;
                        font-size: 1.86rem;
                    }
                    h2{
                        font-size: 1.7rem;
                    }

                    h6 {
                        margin-bottom: 1.1rem;
                        font-size: 0.95rem;
                    }
                    p {
                        margin-bottom: 1.25em;
                        font-size: 1.17rem;
                        line-height: 1.25;
                    }

                    .content_img {
                        margin-bottom: 1.8rem;
                    }

                    blockquote {
                        flex-direction: row-reverse;

                        h3 {
                            margin-bottom: 1.3rem;
                            font-size: 1.42rem;
                            line-height: 1.22;
                        }

                        small {
                            max-width: 90%;
                            font-size: 1.16rem;
                            line-height: 1.2;
                        }

                        img {
                            max-width: 12.3rem;
                            margin-right: -0.6rem;
                        }

                        & > a {
                            padding: 0.9rem 0 3.3rem;
                        }
                    }
                    .app_gallery{
                        .swiper-slide{
                            height: 13rem;
                        }
                        .swiper-button-prev, .swiper-button-next{
                            height: 4rem;
                        }

                    }
                    .app_video{
                        width: 100%;
                        height: 16rem;
                    }
                }
                .blocks {

                }

            }
        }
        .arrows {
            .arrow {
                top: 2rem;
                height: 2.9rem;

                &.prev {
                    left: 0.6rem;
                }

                &.next {
                    right: 0.6rem;
                }
            }
        }
        .sharing{
            margin-top: -0.8rem;
            margin-bottom: 5rem;
        }
    }
</style>
